import { RESOURCES_PAGE_URL } from './constants'

export const isItResourcesPage = (pathname) => pathname === RESOURCES_PAGE_URL
